// extracted by mini-css-extract-plugin
export var numpadContainer = "_qt-1";
export var phoneButton = "_qt-0";